<template>
  <page-view title="专家入库审核">
    <template slot="action">
    </template>
    <a-card>
      <a-form-model :model="form"
                    class="exi_form v2"
                    ref="form"
                    :label-col="{ flex: '0 0 auto' }"
                    :wrapper-col="{ span: 24 }">
        <a-form-model-item label="采购品目名称|编码"
                           style="width: 600px">
          <a-input v-model="form.purchaseItem"
                   placeholder="采购品目名称|编码" />
        </a-form-model-item>
        <a-form-model-item label="单位全称"
                           prop="unitName"
                           style="width: 400px">
          <a-input v-model="form.unitName"
                   placeholder="单位全称" />
        </a-form-model-item>
        <a-form-model-item label="专家名称"
                           prop="expertName">
          <a-input v-model="form.expertName"
                   placeholder="专家名称" />
        </a-form-model-item>
        <a-form-model-item label="学历"
                           style="width: 200px"
                           prop="education">
          <dict-cascader dictKey="expert_education"
                         placeholder="学历"
                         v-model="form.education"
                         style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item label="职称"
                           style="width: 200px"
                           prop="professionalTitle">
          <dict-cascader dictKey="expert_professionalTitle"
                         placeholder="职称"
                         v-model="form.professionalTitle"
                         style="width: 100%" />
        </a-form-model-item>
        <a-button type="primary"
                  @click="onSearch()">查询
        </a-button>
        <a-button @click="reset">重置</a-button>
      </a-form-model>
    </a-card>
    <a-card>
      <s-table ref="table"
               :columns="columns"
               :data="loadData"
               :rowKey="record => record.id"
               :pagination="{ showTotal: (total) => `共 ${total} 条` }">
        <template slot="expertName"
                  slot-scope="record">
          <a @click.stop="onViewModal(record)">{{ record.expertName }}</a>
        </template>
        <a-space slot="action"
                 slot-scope="record">
          <a-button type="primary"
                    size="small"
                    :loading="record.auditLoading"
                    @click="auditPass(record)">通过</a-button>
          <a-button type="danger"
                    size="small"
                    :loading="record.auditLoading"
                    @click="auditFail(record)">不通过</a-button>
        </a-space>
      </s-table>
    </a-card>
    <a-modal :visible="auditFailVisible"
             :confirm-loading="confirmLoading"
             @cancel="()=>auditFailVisible=false"
             @ok="handleAuditFail">
      <template slot="title">
        填写 {{ auditFailData.expertName }} 专家不通过入库申请原因
      </template>
      <a-form-model ref="auditFailForm"
                    :model="auditFailData">
        <a-form-model-item ref="auditFailReason"
                           label="不通过原因"
                           prop="auditFailReason"
                           :rules="[{ required: true, message: '请填写不通过原因', trigger: 'blur' },{max: 200,message: '最多200个字',trigger: 'change'}]">
          <a-textarea v-model="auditFailData.auditFailReason"
                      placeholder="请填写不通过原因"
                      :auto-size="{ minRows: 3, maxRows: 5 }" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal width="90%"
             :dialog-style="{ top: '20px' }"
             :visible="expertViewVisible"
             :footer="null"
             :destroyOnClose="true"
             @cancel="()=>expertViewVisible = false">
      <template slot="title">
        {{expertViewData.expertName}} 专家详情
      </template>
      <expert-apply-for-view :info="expertViewData" />
    </a-modal>
  </page-view>
</template>
  
  <script>
import { PageView } from '@/layouts'
import STable from '@/components/Table'
import DictCascader from '@/components/dict/DictCascader'
import { GetExpertStorageApplicationAuditData, UpdateAuditByExpertStorageFile } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'
import expertAuditResultEnum from '@/utils/expertAuditResultEnum'
import ExpertApplyForView from './ExpertApplyForView'

export default {
  name: 'ExpertApplyForAudit',
  computed: {
  },
  components: {
    PageView,
    STable,
    DictCascader,
    ExpertApplyForView
  },
  data () {
    return {
      auditFailVisible: false,
      confirmLoading: false,
      expertViewVisible: false,
      auditFailData: {},
      expertViewData: {},
      form: { auditResult: expertAuditResultEnum.AUDIT_ING },
      columns: [
        { title: '姓名', align: 'center', width: '80px', scopedSlots: { customRender: 'expertName' } },
        {
          title: '性别', align: 'center', width: '80px', dataIndex: 'gender',
          customRender: (text, record) => {
            return text === '1' ? '男' : '女'
          }
        },
        // { title: '年龄', width: '80px', align: 'center', dataIndex: 'extras.age' },
        { title: '采购品目', align: 'left', dataIndex: 'purchaseItem' },
        { title: '学历', align: 'center', width: '120px', dataIndex: 'extras.educationName' },
        { title: '职称', align: 'center', width: '120px', dataIndex: 'extras.professionalTitle' },
        { title: '单位全称', align: 'center', dataIndex: 'unitName' },
        { title: '手机号码', align: 'center', width: '120px', dataIndex: 'mobilePhone' },
        { title: '操作', align: 'center', width: '150px', scopedSlots: { customRender: 'action' } }
      ],
      loadData: async (parameter) => {
        const data = { ...parameter, ...this.form }
        return GetExpertStorageApplicationAuditData(data)
      },
    }
  },
  methods: {
    // 重置
    reset () {
      this.form = { auditResult: 2 }
      this.notExtractStartTime = null
      this.notExtractEndTime = null
      this.reFresh()
    },
    // 搜索
    onSearch () {
      this.reFresh()
    },
    // 刷新
    reFresh (toFirstPage = true) {
      this.$refs.table.refresh(toFirstPage)
    },
    auditPass (record) {
      const that = this
      this.$confirm({
        title: `确认通过 ${record.expertName} 专家的入库申请?`,
        onOk () {
          that.handleAuditPass(record)
        },
      })
    },
    async handleAuditPass (record) {
      record.auditLoading = true
      record.auditStatus = expertAuditResultEnum.AUDIT_RESULT_PASS
      UpdateAuditByExpertStorageFile(record).then(res => {
        if (res.code == 200) {
          this.$message.success("处理成功", 6)
        } else {
          this.$message.error("处理失败", 6)
        }
        record.auditLoading = false
        this.reFresh()
      }).finally(e => {
        record.auditLoading = false
      })
    },
    auditFail (record) {
      console.log(record)
      this.auditFailData = record
      this.auditFailVisible = true
    },
    handleAuditFail () {
      this.$refs.auditFailForm.validate(valid => {
        if (valid) {
          this.confirmLoading = true
          this.auditFailData.auditStatus = expertAuditResultEnum.AUDIT_RESULT_FAIL
          UpdateAuditByExpertStorageFile(this.auditFailData).then(res => {
            if (res.code == 200) {
              this.$message.success("处理成功", 6)
            } else {
              this.$message.error("处理失败", 6)
            }
            this.confirmLoading = false
            this.reFresh()
          }).finally(e => {
            this.confirmLoading = false
          })
        } else {
          return false
        }
      })
    },
    //打开窗口查看信息
    onViewModal (record) {
      this.expertViewData = record
      this.expertViewVisible = true
    },
  }
}
  </script>
  
  <style lang="less" scoped>
.ant-calendar-picker {
  width: 47% !important;
}
.display-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
  